<template>
  <v-card 
    id="card-module-menu"
    :elevation="!$vuetify.breakpoint.mobile ? 5 : 0"
  >
    <v-card-title class="py-1 px-0">
      <v-container v-if="module">
        <v-row>
          <v-col
            class="border-bottom border-nitro border-bold d-flex p-0"
            cols="12"
            order="2"
            order-md="first"
          >
            <v-btn
              :to="{ name: studyNowRouteName }"
              color="primary"
              rounded
              outlined
              class="border-bold-hover"
            >
              <span class="h6 text-none font-weight-bold my-2">
                <span class="h4">&lt;</span> Voltar para <span class="text-capitalize">{{ selectedCycle.cycle_name }}</span>
              </span>
            </v-btn>
          </v-col>
          <v-col
            v-if="!$vuetify.breakpoint.mobile"
            class="px-4"           
          >
            <span class="text-break font-weight-bold text-uppercase h5 mb-0">
              {{ module.type != 'theme' ? module.subject.name : module.block.name }}
            </span>
          </v-col>
          <v-col
            cols="12"
            class="p-2 border-bottom"
            :class="{
              'px-0': isMobile,
            }"
            order="first"
            order-md="2"
          >
            <h5 class="text-break mx-2 mb-0">
              Módulo {{ module.module_order }} <span class="font-weight-black"> | {{ module.name }}</span>
            </h5>
            <p
              class="m-2 mb-0 text-break"
              style="font-size: 15px;"
            >
              {{ module.description }}
            </p>
          </v-col>
          <v-col 
            ref="progress-column"
            cols="12"
            class="py-2 border-bottom"
            :class="{
              'px-0': $vuetify.breakpoint.mobile,
            }"
            order="3"
          >
            <h5
              class="mb-0 ml-1"
              :class="{'m-0': isMobile}"
            >
              <span class="font-weight-semibold text-uppercase">
                progresso no módulo:
              </span>
              <span class="purple--text font-weight-semibold">
                <strong>
                  {{ Math.round(module.module_progress) }}
                </strong>% 
                ({{ module.count_completed_contents }}/{{ module.count_contents }})
              </span>
            </h5>
          </v-col>
          <v-col
            v-if="$vuetify.breakpoint.mobile"
            class="p-4 mb-2 primary white--text d-flex align-items-center"
            cols="12"
            order="last"
          >
            <img
              :src="`/images/${videocast_selected ? 'video' : content.type }_content_icon.svg`"
              width="25px"
              class="inverted"
            > 
            <span
              v-if="videocast_selected"
              class="ml-1 font-weight-bold text-break"
            >
              {{ module.video.title }}
            </span>
            <span
              v-else
              class="ml-1 font-weight-bold text-break"
            >
              {{ content.order + 1 }}. {{ content.title }}
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text
      v-show="!$vuetify.breakpoint.mobile"
      class="p-0"
    >
      <ModuleContentMenu v-if="module" />
    </v-card-text>
  </v-card>
</template>

<script>
import { studyNowRouteName } from '@/student/constants/routes'
import ModuleContentMenu from './ModuleContentMenu.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ModuleContentMenu,
  },
  data() {
    return {
      studyNowRouteName,
    }
  },
  computed: {
    ...mapGetters(['module','selectedCycle','content','videocast_selected']),
  },
}
</script>
